import { render, staticRenderFns } from "./HuaxianAttractProjectList .vue?vue&type=template&id=25d73cd8&scoped=true&"
import script from "./HuaxianAttractProjectList .vue?vue&type=script&lang=js&"
export * from "./HuaxianAttractProjectList .vue?vue&type=script&lang=js&"
import style0 from "./HuaxianAttractProjectList .vue?vue&type=style&index=0&id=25d73cd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d73cd8",
  null
  
)

export default component.exports